import { Page } from '@/core/architecture'

import { ConsoleMembershipCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMembershipCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleMembershipCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMembershipCreateTemplate state={state} {...actions} />
}
